export default __webpack_public_path__ + "static/media/2358.a0d316ee.png";